<template>
    <div class="details Mydetails_order">
        <navbar></navbar>
        <steps :current="0">
            <step :title="$t('order_details_state_1')"></step>
            <step :title="$t('order_details_state_2')"></step>
            <step :title="$t('order_details_state_3')"></step>
        </steps>
        <div class="order-list" style="margin:5% 0;">
            <h3 class="listing details-width">{{$t('user_order_goods_lists')}}</h3>
            <listing :lists="goods_list"></listing>
        </div>
        <my-address @on-checked="onChecked" @on-address="checkAddr" @on-checkstore="checkstore" v-show="isLogin"></my-address>
        <my-payment @on-checked-radio="onChecked_radio"></my-payment>
        <div class="order-payment details-width">
            <div class="pay-left">
                <p class="payment-text">
                    {{$t('user_order_pay_tips')}}</p>
            </div>
            <div class="pay-right">
                <div class="payment-mey" style="display: none">My Coupon：
                    <span>
                        <Input v-model="coupon_code" placeholder="Input coupon code"></Input>
                        <img src="../../assets/store/unfold.png" alt="" width="20" class="mycoupon-sel"
                             @click="show = !show" v-bind:class="{transform: show }">
                        <transition name="fade">
                             <div v-if="show" class="mycoupon-box">
                                 <label v-for="(coupon,index) in coupons" class="profile-radio mycoupon-radio"
                                        @click="checkRadio(index,$event)">
                                     <img src="../../assets/store/coupons.png" alt="">
                                     <span class="pro-radio" v-bind:class="{'pro-radio-checked':tag == index}">
                                        <span class="pro-radio-inner"></span>
                                        <input type="radio" class="pro-radio-input">
                                    </span>
                                 </label>
                             </div>
                        </transition>
                    </span>
                    <p class="text-primary">- USD 00</p>
                </div>
                <p class="payment-mey payment-space">
                    <span>{{$t('user_order_shipping')}}：</span>
                    <span class="text-primary" v-if="ispayment"> USD ${{freight}}</span>
                    <span class="text-primary" v-else>+ USD 0</span>
                </p>
                <p class="payment-mey payment-space">
                    <span>{{$t('user_center_order_total_tip')}}:</span>
                    <span class="text-primary"> USD ${{subtotal}}</span>
                </p>
                <div class="payment-del">
                    <p>
                        <span>{{$t('Order_Details_Payment_Real_Payment')}}: </span>
                        <span class="real-pay text-primary" v-if="ispayment" style="vertical-align: middle;">USD ${{subtotal + freight}}</span>
                        <span class="real-pay text-primary" v-else  style="vertical-align: middle;">USD ${{subtotal}}</span>
                    </p>
                    <p>{{defaultAddress.name}}</p>
                    <p>{{defaultAddress.email}}</p>
                    <p>{{defaultAddress.all_address}}</p>
                </div>
                <p class="payment-mey">
                    <router-link :to="{name:'FooterShop'}">{{$t('continue_purchase')}}</router-link>
                    <span>
                        <button class="btn btn-primary" @click="checkOut">{{$t('check_out_btn')}}</button>
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script scoped>
    import navbar from '../Common/Navbar.vue'
    import Myaddress from './Common/Myaddress.vue'
    import steps from '../MyDetails/Common/Steps.vue'
    import step from '../MyDetails/Common/Step.vue'
    import Mypayment from './Common/Mypayment.vue'
    import modal from '../Common/Modal.vue'
    import listing from './Common/Listing.vue'
    import Signature from '../../lib/Signature'
    import PayType from '../../lib/PayType'

    export default {
        data () {
            return {
                webWidth_num:'',
                coupon_code: '',
                ispayment: true,
                coupon_price: 0,
                storeId: 2,
                isLogin:true,
                show: false,
                tag: 1,
                modal1: false,
                goods_list: [],
                coupons: [],
                defaultAddress: {},
                defaultAddressId: 0,
                addressGroup: [],
                checkType:0,
            }
        },
        components: {
            navbar,
            'my-address': Myaddress,
            steps,
            step,
            'my-payment': Mypayment,
            modal,
            listing
        },
        computed: {
            freight () {
                let fre = 0
                for (let item of this.goods_list) {
                    if (fre < parseFloat(item.shipping_price)) {
                        fre = parseFloat(item.shipping_price)
                    }
                }
                return fre
            },
            subtotal () {
                let total = 0
                for (let item of this.goods_list) {
                    total += parseFloat(item.goods_price) * parseInt(item.goods_num)
                }
                return total
            }
        },
        created () {
            //购物车
            this.fetchData()

            //优惠卷
            this.getCoupon()

            //获取用户信息
            this.getUserAddressList()

            //判断设备尺寸
            this.webWidth()

            //判断用户登录
            if (!this.Local.isLogin()) {
                this.isLogin = false
            }
        },
        methods: {
            webWidth() {
                this.webWidth_num = document.body.clientWidth
            },
            onChecked (index) {
                this.checkType = index
                if (index === 1) {
                    this.defaultAddress = {}
                    this.defaultAddressId = this.Local.set("addressId",0)
                    this.ispayment = false
                } else {
                    if (this.addressGroup.length === 1) {
                        this.defaultAddress = this.addressGroup[0]
                    } else {
                       this.defaultAddressId = this.Local.get("addressId")
                    }
                    this.ispayment = true
                }
            },
            checkstore (id){
                this.storeId = id
            },
            checkAddr (id) {
                this.defaultAddressId = id
                //获取地址详情
                let module = 'index.php/address/detail'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.address_id = id
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        if (parseInt(response.data.code) === 2000) {
                            console.log(response.data)
                            this.defaultAddress = response.data.data
                            this.Local.set('addressId',response.data.data.address_id)
                        }
                    }.bind(this))
            },
            onChecked_radio (index){
                this.tag = index
            },
            //获取用户信息
            getUserAddressList (id) {
                let module = 'index.php/index/user/addressinfo'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        if (parseInt(response.data.code) === 2000) {
                            this.addressGroup = response.data.data.address_info
                            if (this.addressGroup.length > 0) {
                                this.defaultAddress = this.addressGroup[0]
                                this.defaultAddressId = this.addressGroup[0].address_id
                            }
                        }
                    }.bind(this))
            },
            //付款
            checkOut () {
                let module = 'index.php/order'
                let data = {}
                if(this.checkType === 1){
                    data.store_id = this.storeId
                }else{
                    data.store_id = ''
                }
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                //判断用户登录
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    if(this.checkType === 0 && this.defaultAddressId === 0) {
                        this.$Message.error(this.$t('user_place_add_address'))
                        return false
                    }
                    data.user_id = this.Local.getUserId()
                    data.address_id = this.Local.get("addressId")
                }
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.goods_id = this.$route.query.goods_id
                data.number = this.$route.query.number
                data.type = this.tag
                if(this.webWidth_num>768){
                    data.web_type = 1
                }else{
                    data.web_type = 2
                }
                data.redirect_url = 'http://' + window.location.host + '/#/user/order/success'
                data.redirect_error_url = 'http://' + window.location.host + '/#/buy/checkout?goods_id='+data.goods_id+'&number='+data.number
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseInt(resp.data.code) === 2000) {
                            console.log(resp.data)
                            window.location.href = resp.data.data.notify_url
                        }
                        if (parseInt(resp.data.code) === 2001) {
                            this.$Message.error(resp.msg)
                        }

                })
            },
            getCoupon () {
                let module = 'index.php/index/coupon/couponlist'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        if (parseInt(response.data.code) === 2000) {
                            this.coupons = response.data.data.coupon_list
                        }
                    }.bind(this))
            },
            fetchData () {
                let module = 'index.php/cart'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.type = this.$route.query.type
                data.cart_id = this.$route.query.goods_id
                data.number = this.$route.query.number
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        if (parseInt(response.data.code) === 2000) {
                            this.goods_list = response.data.data.goods_list
                        }
                    }.bind(this))
            },
            checkRadio (index, e) {
                this.tag = index
                if (e.target.nodeName === 'INPUT') {
                    this.tag = index
                    this.coupon_code = this.coupons[index].coupon_number
                    this.coupon_price = this.coupons[index].cash_price
                    this.show = false
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../scss/common";


    .order-list {
        font-size: 16px;
        color: #5E6D82;
        letter-spacing: 0;
        line-height: 20px;
        .listing {
            font-size: 24px;
            color: #1F2D3D;
            letter-spacing: 0;
            line-height: 26px;
            font-weight: 400;
        }
        .order-group {
            .order-group-lists {
                .order-group-list {
                    width: 100%;
                }
            }
        }
    }

    .details {
        text-align: left;
        margin: 100px auto 0 auto;
        width: 90%;
        max-width: 1240px;
        @at-root .profile-title {
            font-weight: 500;
            font-size: 40px;
            color: #1F2D3D;
            text-align: left;
        }
        .order-payment {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            margin-bottom: 100px;
            line-height: 24px;
            .pay-left {
                line-height: 2;
                h3 {
                    font-size: 24px;
                    color: #1F2D3D;
                    letter-spacing: 0;
                    line-height: 26px;
                }
                .pay-method {

                }
            }
            .pay-right {
                color: #5E6D82;
                text-align: right;
                .real-pay {
                    font-size: 24px;
                }
            }
        }
    }

    .text-primary {
        color: #0084FF;
    }

    .Mydetails_order {
        .steps {
            max-width: 650px;
            margin: 1% auto;
        }
        .ivu-poptip-inner {
            white-space: normal;
            padding: 10%;
            margin-top: 10px;
            display: none;

            font-size: 14px;
            color: #5E6D82;
        }
        .ivu-steps-status-finish {
            &:hover {
                .ivu-poptip-inner {
                    display: block;

                }
            }
            .ivu-poptip-popper {
                min-width: 180px;
            }
        }
        .payment-text {

            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 20px;
            margin-top: 15px;
        }
        .payment-del {
            border: 1px solid #0084ff;
            padding: 5%;
            border-radius: 5px;
        }
        .payment-mey {
            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 24px;
            margin: 5% 0;
            &.payment-space {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
        }
        .ivu-input-wrapper {
            width: auto;
        }
        .ivu-input {
            background: #FFFFFF;
            border: 1px solid #C0CCDA;
            border-radius: 5px;
        }
        .mycoupon-sel {
            cursor: pointer;
        }
        .mycoupon-box {
            position: absolute;
            width: 100%;
            background: #FFFFFF;
            border: 1px solid #99A9BF;
            border-radius: 5px;
            padding: 2% 5% 5% 5%;
            margin-top: 3%;
        }
        .mycoupon-box span {
            margin: 10% 0 0 5%;
        }
        .mycoupon-radio {
            margin: 5% 0 0 0;
        }
        .transform {
            -webkit-transform: scale(1, -1);
            -moz-transform: scale(1, -1);
            transform: scale(1, -1);
        }
        .pay-check {
            font-family: PingFangSC-Semibold;
            font-size: 22px;
            color: #FFFFFF;
            background: #0084ff;
            margin-left: 30px;
        }
        .fade-enter-active, .fade-leave-active {
            transition: opacity .5s;
            position: absolute;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */
        {
            opacity: 0
        }
        .tip-alert {
            text-align: center;
            .tip-title {
                font-family: PingFangSC-Semibold;
                font-size: 22px;
                color: #1F2D3D;
                letter-spacing: 0;
                line-height: 40px;
            }
            .tip-body {
                /*font-family: PingFangSC-Regular;*/
                font-size: 16px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 24px;
            }
            .tip-button {
                margin-top: 30px;
            }
            .tip-cancel {
                border: 1px solid #5E6D82;
                border-radius: 5px;
                /*font-family: PingFangSC-Regular;*/
                font-size: 16px;
                color: #5E6D82;
                line-height: 24px;
                padding: 6px 30px;
                margin: 0 10px;
            }
            .tip-download {
                background: #0084FF;
                border-radius: 5px;
                font-family: PingFangSC-Semibold;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 24px;
                margin: 0 10px;
            }

        }
    }

    @media screen and (max-width: 768px) {
        .profile-title {
            font-size: 30px;
        }
    }

    @media screen and (max-width: 500px) {
        .order-list {
            .order-group {
                .order-header {
                    display: none;
                }
                .order-row {
                    .goods-header {
                        width: 100px;
                    }
                    div {
                        font-size: 18px;
                        flex: none;
                    }
                    .goods-text {
                        padding: 0 5%;
                    }
                    .goods-desc {
                        h3 {
                            font-size: 14px;
                        }
                    }
                }
            }

        }
        .details .order-payment {
            .pay-right {
                width: 100%;
            }
        }
        .details .order-payment .pay-left {
            display: none;
        }
    }

    @media screen and (max-width: 320px) {
        .order-list {
            .order-group {
                .order-row {
                    .goods-text {
                        padding: 0 3%;
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// Settlement.vue?5dd38554